/**
 * @desc 导出物流订单--海外清关信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportOverseasCustomsClearanceReport/${tmsNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
